import React from "react";
import NumberInput from "./NumberInput";

interface Props {
  currency: server.dto.Currencies
  value: number
  onChange: (value: number) => void
  canBeEmpty: boolean
  canBeNegative: boolean
  maxValue?: number
  focusOnMount?: boolean
  onEnter?: (value: number) => void
  onEsc?: () => void
}

const CurrencyInput = (props: Props) => {
  return <div> <NumberInput
    value={props.value}
    onChanged={v => { props.onChange(v.value); }}
    onEnterPressed={v => { props.onEnter?.(v.value); }}
    onEscPressed={props.onEsc}
    decimalPoints={2}
    canBeEmpty={props.canBeEmpty}
    canBeNegative={props.canBeNegative}
    rightLabel={props.currency.toUpperCase()}
    maxValue={props.maxValue ?? 10000000000}
    width={90}
    focusOnMount={props.focusOnMount}
  /></div>;
};

export default CurrencyInput;